module.exports = __webpack_public_path__ + "static/media/ch-momo.b447f871.jpeg";